import { SosListComponent } from "./sos-list/sos-list.component";
import { SosPanelComponent } from "./sos-panel.component";

export const SosPanelRouting = [
    { path: '', redirectTo: 'map-view', pathMatch: 'full' },
    { path: 'map-view', component: SosPanelComponent },
    { path: 'list-view', component: SosListComponent },
   
];

// export const SosPanelRoutingBreadcrumbs = [

//     { name: 'Map', path: '/map-view' },
//     { name: 'List', path: '/list-view' },
    
// ];